import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=131d6e7e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=131d6e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131d6e7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131d6e7e')) {
      api.createRecord('131d6e7e', component.options)
    } else {
      api.reload('131d6e7e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=131d6e7e&scoped=true&", function () {
      api.rerender('131d6e7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zxp6WqS1Nph1/JS/comp/DateRangeExt.vue"
export default component.exports